// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as firebase from 'firebase'
import VueMoment from 'vue-moment';
import VueScrollTo from 'vue-scrollto';
import Notifications from 'vue-notification';
import { Modal } from 'bootstrap-vue/es/components';

// Bootstrap
Vue.use(Modal);

// Other
Vue.use(VueMoment);
Vue.use(Notifications);
Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created () {
        this.$store.dispatch('initItems');
    },
    methods: {
        isMobileDevice () {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        }
    },
    mounted () {
        // Check to see if extension has been installed
        setTimeout(() => {
            if (typeof(webExtensionWallet) === "undefined" && !this.isMobileDevice()){
                this.$store.commit('updateHasExtension', { hasExtension: false });
            }

            // Remove loader
            this.$store.commit('updateLoading', { loading: false });
        }, 1000);
    }
})



// WEBPACK FOOTER //
// ./src/main.js